"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RawCashUploadConfigSchema = exports.CashUploadOptionSchema = exports.RawUploadConfigSchema = exports.SupplementalTapePropertiesSchema = exports.RepaymentTapePropertiesSchema = exports.CashBalanceFeedPropertiesSchema = exports.LoanTapePropertiesSchema = exports.LenderVerificationConfigSchema = exports.borrowerEligibilityResultsArtifactSlugSchema = void 0;
const finley_types_1 = require("@finley-technologies/finley-types");
const zod_1 = require("zod");
exports.borrowerEligibilityResultsArtifactSlugSchema = zod_1.z
    .record(zod_1.z.string(), zod_1.z.string())
    .describe('Slugs pointing to the borrower eligibility results artifact for each loan product.');
exports.LenderVerificationConfigSchema = zod_1.z.object({
    description: zod_1.z.string(),
    receivableResponseTapeArtifactSlug: zod_1.z
        .string()
        .describe('Slug pointing to the receivable response tape artifact.'),
    borrowingBaseReportArtifactSlug: zod_1.z
        .string()
        .describe('Slug pointing to the borrowing base report artifact.'),
    borrowerNumbersArtifactSlug: zod_1.z
        .string()
        .describe('Slug pointing to the artifact that has borrower numbers extracted.'),
    borrowerEligibilityResultsArtifactSlugs: exports.borrowerEligibilityResultsArtifactSlugSchema,
});
// loan tapes must have loanProductSlug and optionally creditFacilitySlug
exports.LoanTapePropertiesSchema = zod_1.z.object({
    creditFacilitySlug: zod_1.z.string().nullable(),
    loanProductSlug: zod_1.z.string(),
});
// cash balance feed must have creditFacilitySlug
exports.CashBalanceFeedPropertiesSchema = zod_1.z.object({
    creditFacilitySlug: zod_1.z.string(),
});
// repayment tapes are not associated with creditFacilitySlug
exports.RepaymentTapePropertiesSchema = zod_1.z.object({
    loanProductSlug: zod_1.z.string(),
});
// supplemental tapes are not associated with creditFacilitySlug or loanProductSlug
exports.SupplementalTapePropertiesSchema = zod_1.z.object({});
/**
 * Configuration for uploading a file to the borrowing base pipeline.
 * This will be used by BBPL monitor.
 */
exports.RawUploadConfigSchema = zod_1.z.object({
    fileExtension: finley_types_1.Util.SupportedFileExtensionSchema.nullable().describe('Type of file supported for upload. For cashBalanceFeedContext this will be null.'),
    baseFilename: zod_1.z
        .string()
        .describe('BaseFile name (example: orgSlug/cfslug/flexloantape) to be used for uploading the file.'),
    externalDisplayName: zod_1.z
        .string()
        .describe('Surfaced on UI by Data Pipeline like "Flex Loan Tape | Fx Supplemental Tape | Cash Balance Feed | etc."'),
    meshName: zod_1.z
        .string()
        .optional()
        .describe('Optional mesh name for the mesh that this file belongs to.'),
});
exports.CashUploadOptionSchema = zod_1.z.enum(['tape', 'fetch', 'form']);
exports.RawCashUploadConfigSchema = exports.RawUploadConfigSchema.extend({
    cashUploadOptions: zod_1.z
        .array(exports.CashUploadOptionSchema)
        .optional()
        .describe('Options to upload cash balances.'),
});
//# sourceMappingURL=tape-builder-base.js.map